import axios from "axios"
import { fillingOrderTypes } from "redux/reducers/fillingOrder/types"
import { PROYECT, api_get, api_put } from "services/api"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"
import { formatCustomDate } from "helpers/dateTools"
import { getItemLocalStorage } from "helpers/localstorageTool"
import { addPrintQueue } from "../printers/printersActions"
import { getMaskedOrderNumbers } from "helpers/maskOrders"

const {
  DELETE_FILLING_ORDERS,
  GET_FILLING_ORDERS,
  FILLING_ORDER_INPUTS,
  FILLING_ORDER_DESELECT_PENDING,
  FILLING_ORDER_SELECT_PENDING,
  FILLING_ORDER_SELECT,
  FILLING_ORDER_DESELECT,
} = fillingOrderTypes

export const setFillingOrderInputs = (key, value) => {
  return {
    type: FILLING_ORDER_INPUTS,
    payload: { key, value },
  }
}

export const getFillingOrders = (startDate, endDate, station) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders?start=${startDate}&end=${endDate}&idStation=${station}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingFillingOrder'))
    await api_get(url).then(resp => {
      if (resp.length === 0) dispatch(setSnackbar('No se encontraron ordenes'))
      dispatch({
        type: GET_FILLING_ORDERS,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error || 'Error contacte a soporte'))
    })
    dispatch(stopRequestComp('loadingFillingOrder'))
  }
}

export const deleteFillingOrder = (ids) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders/cancel`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingFillingOrder'))
    await api_put(url, ids).then(resp => {
      const errorIds = []
      const goodIds = []
      resp.forEach((order, index) => {
        if(order.includes('Error')) errorIds.push(ids[index])
        else goodIds.push(ids[index])
      })
      dispatch({
        type: DELETE_FILLING_ORDERS,
        payload: {
          errorIds,
          goodIds
        }
      })
      if(errorIds.length) dispatch(setSnackbar(`Error con ${errorIds.length} ordenes`))
    }).catch(error => {
      dispatch(setSnackbar(error || 'Error contacte a soporte'))
    })
    dispatch(stopRequestComp('loadingFillingOrder'))
  }
}

export const selectAllPendingFillingOrderDelete = () => {
  return {
    type: FILLING_ORDER_SELECT_PENDING
  }
}

export const deselectAllPendingFillingOrderDelete = () => {
  return {
    type: FILLING_ORDER_DESELECT_PENDING
  }
}

export const selectFillingOrderDelete = (id) => {
  return {
    type: FILLING_ORDER_SELECT,
    payload: id,
  }
}

export const deselectFillingOrderDelete = (id) => {
  return {
    type: FILLING_ORDER_DESELECT,
    payload: id,
  }
}

// Genera el ticket de la orden de llenado (PDF). Si download es verdadero lo
// encola en la cola de impresión; en caso contrario abre el PDF en una pestaña.
export const getTicketFillingOrder = (
  date,
  unit,
  order,
  download,
  action = null,
  folio = ""
) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders/ticket`;
  const body = {
    date: formatCustomDate(date, '-'),
    unit,
    orders: order.map(item => item.numberOrderExtra),
    folio: `${folio ?? ''}`,
  };
  const fileName = `orden-llenado-${order.map(i => i.numberOrderExtra).join('-')}.pdf`;
  return async dispatch => {
    const token = getItemLocalStorage('crm-user')
    dispatch(startRequestComp('loadingDownloadPDF'))
    await axios.post(url, body, {
      responseType: 'blob', headers: {
        Authorization: `${token}`,
      }
    })
      .then(async resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', `_blank`);
        document.body.appendChild(link);
        if (download) {
          dispatch(addPrintQueue({
            url: url,
            fileName: `${fileName}`
          }))
        } else {
          link.click()
          window.URL.revokeObjectURL(url);
        }
        link.remove();
        action && action()
      })
      .catch(error => {
        dispatch(setSnackbar(error));
      });
    dispatch(stopRequestComp('loadingDownloadPDF'))
  }
};

// Puente para enmascarar órdenes:
//   1) lee la configuración de unidades del estado (vía selector inyectado),
//   2) enmascara las órdenes con getMaskedOrderNumbers,
//   3) despacha getTicketFillingOrder.
// El selector permite que cada dominio use su slice (por defecto,
// unitsReducer.unitsConfigArr; carburaciones pasa carburations.unitConfigs).
export const printFillingOrderTicket = ({
  date,
  unit,
  unitId,
  orders,
  folio = "",
  download = true,
  action = null,
  selectUnitConfigs = (state) => state.unitsReducer.unitsConfigArr,
  skipMasking = false,
}) => (dispatch, getState) => {
  const unitConfigs = selectUnitConfigs(getState());
  const displayedOrders = skipMasking
    ? orders
    : getMaskedOrderNumbers({ unitConfigs, unitId, orders });
  return dispatch(getTicketFillingOrder(date, unit, displayedOrders, download, action, folio));
};
